// Consultations axios instance. Sends X-Auth-Token on every request.
import axios from "axios";
import { toast } from "sonner";
import { getToken, clearToken } from "./authSession";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND}/api/consultations`,
});

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers["X-Auth-Token"] = t;
  return config;
});

let _redirecting = false;

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !_redirecting) {
      _redirecting = true;
      clearToken();
      if (typeof window !== "undefined") {
        try {
          toast.error("Session expired. Please sign in again.", {
            duration: 4000,
          });
        } catch { /* no-op */ }
        setTimeout(() => {
          window.location.href = "/outreach";
        }, 400);
      }
    }
    return Promise.reject(err);
  },
);


export const bloodworkApi = axios.create({
  baseURL: `${BACKEND}/api/bloodwork`,
});

bloodworkApi.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers["X-Auth-Token"] = t;
  return config;
});

bloodworkApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !_redirecting) {
      _redirecting = true;
      clearToken();
      if (typeof window !== "undefined") {
        try {
          toast.error("Session expired. Please sign in again.", { duration: 4000 });
        } catch { /* no-op */ }
        setTimeout(() => { window.location.href = "/outreach"; }, 400);
      }
    }
    return Promise.reject(err);
  },
);
